/* eslint-disable filenames/match-exported */

import React from 'react';
import ENV from '~/constants/ENV';
import checkKioskMode from '~/helpers/deviceChecks/checkKioskMode';
import fetchFromExtension from '~/helpers/deviceChecks/fetchFromExtension';
import getDeviceId from '~/helpers/deviceChecks/getDeviceId';
import { extractUserAgentInfo } from '~/helpers/deviceChecks/getOsInfo';
import { AppContextStateType } from '~/types';
import AppContext, { appContextInitialState } from '.';
interface Props {
  children: React.ReactNode;
}
interface IAppContextValue {
  actions: {
    update: (context: Partial<AppContextStateType>) => Promise<void>;
  };
  state: AppContextStateType;
}
export class AppContextProvider extends React.Component<Props, AppContextStateType> {
  state: AppContextStateType = appContextInitialState;
  async componentDidMount(): Promise<void> {
    await this._setInitialState();
  }
  setStateAsync = (state: Partial<AppContextStateType>): Promise<void> => {
    // eslint-disable-next-line promise/avoid-new
    return new Promise((resolve): void => {
      this.setState(state as AppContextStateType, resolve);
    });
  };
  _update = async (context: Partial<AppContextStateType>): Promise<void> => {
    await this.setStateAsync(context);
  };
  _setInitialState = async (): Promise<void> => {
    await this.setStateAsync({
      deviceIdIsLoading: true
    });
    const os = extractUserAgentInfo(window.navigator.userAgent);
    const {
      registrationDetails
    } = this.state;
    const [extensionVersionResult, deviceId, isKioskMode] = await Promise.allSettled([fetchFromExtension('EXTENSION_VERSION'), getDeviceId(os?.name, registrationDetails), checkKioskMode(os?.name, registrationDetails)]);
    await this.setStateAsync({
      deviceId: (deviceId.status === 'fulfilled' ? deviceId.value : undefined) || ENV.DEVICE_ID_FALLBACK || '',
      deviceIdIsLoading: false,
      extensionVersion: extensionVersionResult.status === 'fulfilled' ? extensionVersionResult.value.data?.version : undefined,
      isKioskMode: isKioskMode.status === 'fulfilled' ? isKioskMode.value : false,
      operatingSystem: os?.name
    });
  };
  _getContextValue(): IAppContextValue {
    return {
      actions: {
        update: this._update
      },
      state: {
        ...this.state
      }
    };
  }
  render(): React.ReactNode {
    const {
      children
    } = this.props;
    return <AppContext.Provider value={this._getContextValue()} data-sentry-element="unknown" data-sentry-component="AppContextProvider" data-sentry-source-file="provider.tsx">
        {children}
      </AppContext.Provider>;
  }
}
export default AppContextProvider;